import { useMap } from "react-map-gl/maplibre";
import {
	CustomSearchDrawer,
	GeolocationDrawer,
	MapMenuDrawer,
	MeasureDrawer,
	StreetviewDrawer,
} from "ui-components";

import { useGetCurrentMap } from "~map-view/queries/useGetCurrentMap";
import { useCloseMapTool, useCurrentMapToolView } from "~map-view/states";
import { LegendTool } from "~map-view/views/map-view/map-tools/legend";

import { BookmarksDrawer } from "./bookmarks";
import { FeaturesInfoDrawer } from "./features-info";
import { ProximityToolDrawer } from "./proximity";
import { QueryTool } from "./query";
import { SearchDrawer } from "./search";
import { SketchToolDrawer } from "./sketch";

export const DrawerContent = () => {
	const { default: mapRef } = useMap();
	const currentMapToolView = useCurrentMapToolView();
	const closeMapTool = useCloseMapTool();
	const { data } = useGetCurrentMap();

	const onLaunchSteetview = () => {
		if (mapRef) {
			const center = mapRef.getCenter();
			window.open(
				`https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=${center.lat},${center.lng}`,
				"_blank",
			);
		}
	};

	switch (currentMapToolView) {
		case "query":
			return <QueryTool />;
		case "measure":
			return <MeasureDrawer onClose={closeMapTool} />;
		case "custom-search":
			return <CustomSearchDrawer onClose={closeMapTool} />;
		case "geolocation":
			return <GeolocationDrawer onClose={closeMapTool} />;
		case "features-info":
			return <FeaturesInfoDrawer />;
		case "bookmarks":
			return <BookmarksDrawer />;
		case "legend":
			return <LegendTool />;
		case "proximity":
			return <ProximityToolDrawer />;
		case "sketch":
			return <SketchToolDrawer />;
		case "map-menu":
			return (
				<MapMenuDrawer
					title={data?.name ?? ""}
					description={data?.description ?? ""}
					onClose={closeMapTool}
				/>
			);
		case "streetview":
			return (
				<StreetviewDrawer
					onClose={closeMapTool}
					onLaunchSteetview={onLaunchSteetview}
				/>
			);
		case "search":
			return <SearchDrawer />;
		default:
			return null;
	}
};
